import React from 'react';
import { Container, Stack } from '@fiverr-private/layout_components';
import { SearchBar as FiverrSearchBar } from '@fiverr-private/search_bar';
import { SUBMIT_BUTTON_TYPE } from '@fiverr-private/search_bar/src/utils/constants';
import { translate } from '../../../shared/helpers';
import { sendMixpanelEvent } from '../utils/mixpanel';
import { MIXPANEL_EVENTS } from '../utils/eventNames';
import { SEARCH_SOURCE } from './constants';
import { containerClass, customSearchBarClass } from './styles.ve.css';

const SearchBar: React.FC = () => {
  const handleSearchSubmit = (searchQuery: string) => {
    sendMixpanelEvent({
      eventName: MIXPANEL_EVENTS.SUBMITTED_SEARCH,
      clickedElementText: searchQuery,
    });
  };

  return (
    <Stack
      className={`${containerClass} ${customSearchBarClass}`}
      data-search-bar="brand"
      justifyContent="center"
      alignItems="center"
      onClick={() => {
        sendMixpanelEvent({
          eventName: MIXPANEL_EVENTS.CLICKED_SEARCH_BAR,
        });
      }}
    >
      <Container position="relative" height="100%" width="100%">
        <FiverrSearchBar
          placeholder={translate('v17.search.placeholder')}
          submitButtonType={SUBMIT_BUTTON_TYPE.BUTTON_INSIDE}
          dimBackgroundEnabled={false}
          submitOnSuggestionSelected={true}
          submitOnEnter={true}
          source={SEARCH_SOURCE}
          onSubmit={handleSearchSubmit}
        />
      </Container>
    </Stack>
  );
};

export default SearchBar;
